module.exports = __webpack_public_path__ + "img/haberfeld.146e7c6c.png";